export const SHOP_ADMIN_ACCOUNT_PAGES_URLS = {
  home: '/compte',
  password: '/compte/maj-mot-de-passe',
  'personal-data': '/compte/donnees-personnelles',
  'new-address': '/compte/adresse/creation',
  'edit-address': '/compte/adresse/edition',
};
